export const THEMES = Object.freeze({
  TGC: 'tgc',
  LB: 'lb'
})
